// extracted by mini-css-extract-plugin
export var actionButton = "_83-0";
export var attachmentLine = "_83-1";
export var fileInput = "_83-2";
export var fileUploadWrapper = "_83-4";
export var footer = "_83-3";
export var modalContent = "_83-5";
export var paperclip = "_83-6";
export var quillEditor = "_83-7";